import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

export const NgfwNode = (props) => {
    return <NodeWithMultipleHandles {...props} nodeType="ngfw" />;
};
